import { css } from '@emotion/react';
import { formatCentsToCurrency } from '@frontend/currency';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Stepper } from '@frontend/design-system';
import { useStripePortalPayment } from '../hooks';
import { StripePatientDetailsStep, StripePaymentMethodStep, StripeBillingDetailsStep } from './steps';
import { useStripeStepper } from './stripe-stepper-context';

const styles = {
  stepper: css`
    margin-left: 0;
    margin-right: 0;
  `,
  stepperCard: css`
    background-color: ${theme.colors.white};
  `,
};
interface StripeStepperBodyProps {
  amount: number;
  onSubmit: () => void;
  onExpressSubmit: () => void;
}

export const StripeStepperBody = ({ amount, onExpressSubmit, onSubmit }: StripeStepperBodyProps) => {
  const { t } = useTranslation('weave-pay');
  const { paymentRequest, portalStepperSettings } = useStripeStepper();
  const { paymentSuccessfullyCompleted } = useStripePortalPayment();

  return (
    <>
      <Stepper hideStepTitle css={styles.stepper} alwaysRender>
        <Stepper.Card
          css={styles.stepperCard}
          stepValue={`${paymentRequest?.person?.firstName} ${paymentRequest?.person?.lastName} ${formatCentsToCurrency(
            paymentRequest?.amount
          )}`}
          preventDefaultOnClick={paymentSuccessfullyCompleted}
        >
          <StripePatientDetailsStep amount={amount} oneTimeRequest={portalStepperSettings.oneTimeRequest} />
        </Stepper.Card>
        <Stepper.Card
          css={styles.stepperCard}
          stepValue={t('Payment Method')}
          preventDefaultOnClick={paymentSuccessfullyCompleted}
        >
          <StripePaymentMethodStep
            allowSavingACHOnFile={portalStepperSettings.allowSaveACHOnFile}
            allowSavingCardOnFile={portalStepperSettings.allowSaveCardOnFile}
            showExpressPaymentElement={portalStepperSettings.showExpressElement}
            onSubmit={onExpressSubmit}
          />
        </Stepper.Card>
        <Stepper.Card
          css={styles.stepperCard}
          stepValue={t('Billing Information')}
          preventDefaultOnClick={paymentSuccessfullyCompleted}
        >
          <StripeBillingDetailsStep onSubmit={onSubmit} />
        </Stepper.Card>
      </Stepper>
    </>
  );
};
